import { render, staticRenderFns } from "./itemsReq.vue?vue&type=template&id=4252b1a2&scoped=true&"
import script from "./itemsReq.vue?vue&type=script&lang=js&"
export * from "./itemsReq.vue?vue&type=script&lang=js&"
import style0 from "./itemsReq.vue?vue&type=style&index=0&id=4252b1a2&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252b1a2",
  null
  
)

export default component.exports